import { render, staticRenderFns } from "./ReportingSection.vue?vue&type=template&id=da08c8f8&scoped=true"
import script from "./ReportingSection.vue?vue&type=script&lang=js"
export * from "./ReportingSection.vue?vue&type=script&lang=js"
import style0 from "./ReportingSection.vue?vue&type=style&index=0&id=da08c8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da08c8f8",
  null
  
)

export default component.exports